<app-full-text-header [trademarkName]="trademarkName"></app-full-text-header>
<div class="container-main">
  <div class="top-container-fixed">
    @for (i of trademarkFieldTopList; track i) {
    <div class="item">
      <div>
        <strong>{{ i.field }}</strong>
      </div>
      <div>{{ i.value }}</div>
    </div>
    }
  </div>
  <div class="content-container fulltexts">
    <div
      id="fullTextLeftPanel"
      class="full-text"
      [innerHTML]="fulltext | safeHtml"
    ></div>
  </div>
</div>
